import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import couponTypes from './types';

import { sagaErrorDispatcher, sagaCallService, pushGTMEvent } from 'Helpers';
import routes from 'Pages/router/constants/routes';
import couponActions from './actions';
import services from './services';

function* getCouponRequest(action) {
	const appendMeta =
		typeof action.append === 'object' && action.append ? action.append : {};
	const { failedEventName, business } = appendMeta;
	try {
		let response = yield sagaCallService(
			services.getCouponList,
			action,
			action.payload
		);
		const coupons = response?.data?.data;
		const hasNoCoupon = !Array.isArray(coupons) || coupons.length === 0;

		// Only boolean `true` means pagination append; metadata objects must not append.
		yield put(
			couponActions.getCouponsSuccess(response, action.append === true)
		);

		if (hasNoCoupon && failedEventName) {
			pushGTMEvent(failedEventName, {
				vendor_name: business?.name || '',
				vendor_id: business?.v3_id || '',
			});
		}
	} catch (e) {
		if (failedEventName) {
			pushGTMEvent(failedEventName, {
				vendor_name: business?.name || '',
				vendor_id: business?.v3_id || '',
			});
		}
	}
}

function* invalidateCouponRequest(action) {
	const { successEventName, failedEventName, business } = action.payload || {};
	try {
		let response = yield sagaCallService(
			() => services.invalidateCoupon(action.payload),
			action
		);

		pushGTMEvent(successEventName, {
			vendor_name: business?.name || '',
			vendor_id: business?.v3_id || '',
		});
		if (action?.payload?.manageRedirection) {
			const redirectPath =
				action.payload.redirectPath || routes.couponRedemptionOtherWay;
			sessionStorage.setItem('redirect', redirectPath);
			yield (window.location = '/pwa' + redirectPath);
		} else yield put(couponActions.invalidateCouponsSuccess(response?.data));
	} catch (e) {
		if (failedEventName) {
			pushGTMEvent(failedEventName, {
				vendor_name: business?.name || '',
				vendor_id: business?.v3_id || '',
			});
		}
		yield sagaErrorDispatcher(
			e,
			action,
			couponActions.invalidateCouponsFailure
		);
	}
}

function* mobileCouponRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.getCouponListBaseOnMobile(action.payload),
			action
		);
		yield put(couponActions.getCouponsSuccess(response));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, couponActions.getCouponsFailure);
	}
}
function* orderCouponRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.getCouponListByOrderId(action.payload),
			action
		);
		yield put(couponActions.getCouponsSuccess(response));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, couponActions.getCouponsFailure);
	}
}

function* invalidationSearchCouponRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.getMerchantInvalidationSearch(action.payload),
			action
		);
		yield put(
			couponActions.getCouponsSuccess(response, action.append === true)
		);
	} catch (e) {
		yield sagaErrorDispatcher(e, action, couponActions.getCouponsFailure);
	}
}

const couponSaga = [
	takeEvery(couponTypes.GET_COUPON.REUQEST, getCouponRequest),
	takeLatest(couponTypes.INVALIDATE_COUPON.REUQEST, invalidateCouponRequest),
	takeLatest(couponTypes.GET_COUPON_MOBILE.REUQEST, mobileCouponRequest),
	takeLatest(couponTypes.GET_COUPON_ORDER.REUQEST, orderCouponRequest),
	takeLatest(
		couponTypes.GET_COUPON_INVALIDATION_SEARCH.REUQEST,
		invalidationSearchCouponRequest
	),
];
export default couponSaga;
